import { render } from "./inq_info.vue?vue&type=template&id=82720a22"
import script from "./inq_info.vue?vue&type=script&lang=js"
export * from "./inq_info.vue?vue&type=script&lang=js"

import "./inq_info.vue?vue&type=style&index=0&id=82720a22&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__